module.exports = __webpack_public_path__ + "img/helpDp.asset.1b0cbe90.svg";